import React from "react";
import UserTopbar from "../components/UserTopbar";

const withDashboardAccess = (WrappedComponent) => {
    return (props) => {
        const codeSign = localStorage.getItem("_code_sign");

        if (codeSign === "LIXIL/5087") {
            return (
                <>
                    <UserTopbar heading="404" />
                    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-6">
                        <div className="text-center max-w-lg">
                            <h1 className="text-7xl font-bold text-gray-900">404</h1>
                            <p className="mt-3 text-gray-500">
                                Page not found.
                            </p>
                        </div>
                    </div>
                </>
            );
        }

        return <WrappedComponent {...props} />;
    };
};

export default withDashboardAccess;
